import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeListWrapper',
  props: {
    color: null
  },
  setup(__props: any) {

const store = useStore();



const isDesktop = computed(() => store.state.layout.isDesktop);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["panel-scrollable flex-grow-1 relative", [`panel-info-${__props.color}`]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'panel-scrollable-content': _unref(isDesktop) })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["gutter-s3 text-sm", `text-${__props.color}`])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 2)
  ], 2))
}
}

})